import Vue from 'vue'
import { createAndMountInstance } from 'util/loader-helper'
import { SubdimensionTeaserConfig as ISubdimensionTeaserConfig } from 'services/api-service'
import SubdimensionTeaserWidget from './subdimension-teaser'
import { widgetLibraries } from 'init/command-queue'

// since there can be multiple subdimension teasers on the same page, need to account for by
// storing configs and instances by the widgetDivId
const configsByWidgetDivId: { [name: string]: ISubdimensionTeaserConfig } = {}
const instances: { [name: string]: Vue } = {}

export const type = 'subdimension-teaser'

// initialize all subdimension teasers on the page
export function initializeAll() {
  return Promise.all(Object.keys(configsByWidgetDivId).map(widgetDivId => initialize(widgetDivId)))
}

// initialize a specific subdimension teaser on the page
export function initialize(widgetDivId: string) {
  const props = { teaserConfig: configsByWidgetDivId[widgetDivId] }
  return createAndMountInstance(
    instances[widgetDivId],
    SubdimensionTeaserWidget,
    widgetDivId,
    props
  ).then(instance => instances[widgetDivId] = instance)
}

// since there can be multiple subdimension teasers on the same page, passing an array instead of
// the single configuration used by other widgets
export function loadWidget(widgetConfigs: ISubdimensionTeaserConfig[]) {
  // because of the dynamic nature of these configs, didn't bother with a config object
  // there is a default heading level that should be set if not.  Setting here.
  widgetConfigs.forEach(wc => wc.headingLevel = wc.headingLevel || 3)
  widgetLibraries.subdimensionTeaser = {}
  widgetConfigs.forEach(wc => configsByWidgetDivId[wc.widgetDivId] = wc)
  return initializeAll()
}

export function getWidgetDivIds() {
  return Object.keys(configsByWidgetDivId)
}

export function getInstances() {
  return instances
}
